import * as actionTypes from './actionTypes';
import * as api from '../api';
import { persona as personaSchema, arrayOfPersonas as arrayOfPersonasSchema, normalize} from '../../helpers/schema';
import { createActionObject, getAjaxFunc } from '../../helpers/common';

export const fetchAll = () => dispatch => getAjaxFunc(
  actionTypes.FETCH_PERSONAS_REQUEST,
  "",
  actionTypes.FETCH_PERSONAS_FAILURE,
  "",
  dispatch
)(
  () => api.fetchAll()
  .then(({ status, data }) => {
    switch(status){
      case 500:
        dispatch(
          createActionObject(
            actionTypes.FETCH_PERSONAS_FAILURE
          )
        );
        break;
      default:
        dispatch(
          createActionObject(
            actionTypes.FETCH_PERSONAS_SUCCESS,
            {
              ...normalize(data, arrayOfPersonasSchema),
            }
          )
        );
    }
  })
)()

export const create = name => dispatch => getAjaxFunc(
  actionTypes.CREATE_PERSONA_REQUEST,
  "",
  actionTypes.CREATE_PERSONA_FAILURE,
  "",
  dispatch
)(
  api.create({ name })
  .then(({ status, data }) => {
    switch(status){
      case 500:
        dispatch(
          createActionObject(
            actionTypes.CREATE_PERSONA_FAILURE
          )
        );
        break;
      default:
        dispatch(
          createActionObject(
            actionTypes.CREATE_PERSONA_SUCCESS,
            {
              ...normalize(data, personaSchema)
            }
          )
        )
    }
  })
)